import { createFileRoute } from '@tanstack/react-router';
import GroupsMainPage from '@/pages/groups/GroupsMainPage';

/**
 * Main-content groups list — same card layout as folders inside a group.
 */
export const Route = createFileRoute('/_authenticated-layout/groups/')({
  component: GroupsMainPage,
});
